
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31034",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31034",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55621",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8523",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11971",
  "I18n": "static-7.1709",
  "quartz": "static-1.7677",
  "quartz-config": "static-1.1455",
  "quartz-core": "static-1.6896",
  "react-dlb": "static-1.94",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1107",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55608",
  "feedback-utils": "static-1.55612",
  "forms-embed-utils-lib": "static-1.4945",
  "forms-utils-lib": "static-1.13351",
  "foundations-assets": "static-1.5373",
  "foundations-components": "static-1.8763",
  "foundations-theming": "static-1.4974",
  "hub-http": "static-1.6690",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12278",
  "icons": "static-2.704",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4236",
  "raven": "static-3.5925",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17222",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5663",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.518",
  "tinymce-plugins": "static-1.58526",
  "transmute": "static-2.97",
  "ui-images": "static-2.1278",
  "UIComponents": "static-3.8917",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3954",
  "quartz-webpack": "static-1.3901",
  "foundations-theming-specialty": "static-1.2690",
  "property-description-translator": "static-1.4304",
  "HeadJS": "static-2.824",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3634",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4791",
  "jasmine-runner": "static-1.6937",
  "opentelemetry-fe-types": "static-1.275",
  "dispatcher": "static-1.148",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4980",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.650",
  "quartz-auth": "static-1.1352",
  "quartz-head": "static-1.1342",
  "quartz-i18n": "static-1.1352",
  "quartz-routing": "static-1.1107",
  "quartz-test": "static-1.1352",
  "quartz-tracking": "static-1.1056",
  "trellis-components": "static-1.3132",
  "ui-fonts": "static-1.1233",
  "usage-tracker-container": "static-1.7798",
  "usage-tracker-core": "static-1.7658",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.373",
  "conversations-skeleton-state": "static-1.7608",
  "reference-resolvers": "static-1.8668",
  "sanitize-text": "static-1.8643",
  "PatternValidationJS": "static-1.3368",
  "ReduxMessenger": "static-2.10854",
  "outpost": "static-1.4613",
  "rpc-client-utils": "static-1.5154",
  "sanitize": "static-1.4959",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5032",
  "floating-ui": "static-1.68",
  "hs-story-utils": "static-1.9914",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3113",
  "bend-plugin-foundations-theming": "static-1.3457",
  "foundations-theming-base": "static-1.3959",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.407",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.184",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10041",
  "atom": "static-1.5556",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8437",
  "ContentUtils": "static-1.69499",
  "data-token-picker": "static-1.17150",
  "file-manager-components": "static-1.24861",
  "FileManagerCore": "static-1.40360",
  "FileManagerLib": "static-1.40501",
  "frontend-preferences-client": "static-1.8405",
  "hub-http-contrib": "static-1.3517",
  "interframe": "static-3.5226",
  "layout-dnd-components": "static-1.13242",
  "layout-dnd-utils": "static-1.12217",
  "property-translator": "static-1.5864",
  "react-codemirror": "static-1.11126",
  "react-colorpicker": "static-2.10694",
  "reference-resolvers-lite": "static-1.8597",
  "rich-text-lib": "static-1.20570",
  "tinymce-data": "static-1.41497",
  "tinymce-themes": "static-1.57382",
  "ui-addon-emoji-picker": "static-1.10347",
  "ui-addon-sales-email": "static-1.5686",
  "ui-brand-identity-lib": "static-1.16976",
  "bender-build-tools": "static-1.3600",
  "opentelemetry-web": "static-1.23",
  "hub-http-shared-msw-handlers": "static-1.10921",
  "hubspotter-http-shared-msw-handlers": "static-1.10919",
  "usage-tracker-session-replay": "static-1.5494",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1496",
  "tanstack-virtual": "static-1.43",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.564",
  "chirp-fetch": "static-1.2389",
  "stylex-utils": "static-1.176",
  "chatspot-core": "static-1.23941",
  "copilot-toolkit": "static-1.12171",
  "customer-data-objects-ui-components": "static-1.13520",
  "data-fetching-client": "static-1.10124",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5243",
  "ui-addon-video-player": "static-1.9107",
  "ui-coaching-tips": "static-1.29593",
  "usage-tracker": "static-1.7808",
  "cms-field-types": "static-1.5294",
  "content-icons-ui": "static-1.2466",
  "integrations-lib": "static-1.17451",
  "customer-data-objects": "static-1.8191",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2223",
  "apollo-link-hub-http": "static-2.5073",
  "apollo-stack-hubspot": "static-3.99",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4626",
  "poll-commands": "static-1.3962",
  "ui-addon-iframeable": "static-1.9561",
  "video-components-external": "static-1.12459",
  "video-data-lib": "static-1.36117",
  "audio-components": "static-1.6587",
  "breeze-artifacts-sdk": "static-1.1010",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30075",
  "FileManagerImages": "static-1.38012",
  "foundations-components-legacy": "static-1.1788",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.742",
  "ui-universal-auth": "static-1.9763",
  "urlinator": "static-1.4998",
  "video-components": "static-1.14461",
  "video-embed": "static-1.36951",
  "ts-schema": "static-1.4400",
  "ContentData": "static-1.69574",
  "layout-data-lib": "static-1.10542",
  "react-dnd-compat": "static-1.5094",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2033",
  "external-options-client-types": "static-1.4444",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6076",
  "hs-resources": "static-1.671",
  "inbound-db-properties-service-client": "static-1.4156",
  "NamespacedHubStyle": "static-2.9373",
  "growth-onboarding-confetti": "static-1.3543",
  "SharedI18nStrings": "static-1.188",
  "ui-addon-i18n": "static-1.11629",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5915",
  "magpie-types": "static-1.5375",
  "simple-logging-lib": "static-1.3535",
  "avatar-components": "static-1.2971",
  "customer-data-ui-utilities": "static-1.10316",
  "growth-onboarding-feedback-components": "static-1.7065",
  "flux-actions": "static-1.381",
  "hubspot-apollo-client": "static-1.5367",
  "integrations-error-boundary-lib": "static-1.14866",
  "integrations-tracking-lib": "static-1.6107",
  "laboratory-lib": "static-3.7632",
  "native-integrations-shared-strings": "static-1.8247",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10765",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1201",
  "breeze-engine-core": "static-1.1501",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1132",
  "navigation-messaging": "static-1.8517",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19656",
  "nudge-client-utils": "static-1.3439",
  "custom-vendor-connection-lib": "static-1.327",
  "unified-auth-core-lib": "static-1.1559",
  "social-insights-client-types": "static-1.22948",
  "advanced-menus-core": "static-1.15831",
  "advanced-menus-lib": "static-1.12580",
  "ExportDialog": "static-6.10858",
  "ui-memberships-settings-lib": "static-1.35221",
  "conditional-properties-service-client": "static-1.4118",
  "crm-pipelines-api-client-types": "static-1.4449",
  "event-emitter": "static-1.1446",
  "fdsr-migration-layer": "static-1.496",
  "framework-builder-read-service-client": "static-1.4340",
  "inbound-db-meta-service-client": "static-1.3780",
  "multi-currency-client-types": "static-1.4013",
  "foundations-components-test-utils": "static-1.6246",
  "reactive-lib": "static-1.1205",
  "trellis-migration-context": "static-1.65",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.826",
  "universal-page-editor-lib": "static-1.3497",
  "bend-plugin-pulse": "static-1.635",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30827",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3196",
  "nudge-renderer-utils": "static-1.3515",
  "onboarding-tours": "static-1.17411",
  "whisper-core-api": "static-1.7656",
  "fsm": "static-1.4242",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15830",
  "simple-menus-lib": "static-1.17347",
  "settings-ui-lib": "static-1.13012",
  "persist-promise": "static-1.4190",
  "crm-record-cards-client": "static-1.80",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7377",
  "location-customization-utils-lib": "static-1.10441",
  "getting-started-shared-tasks": "static-1.19583",
  "growth-data-modal": "static-1.6149",
  "growth-onboarding-next-action-utils": "static-1.3003",
  "navigation-components": "static-1.19190",
  "nest": "static-1.719",
  "onboarding-tours-client": "static-1.5626",
  "onboarding-tours-utils": "static-1.1478",
  "ui-shepherd-tracker": "static-1.8146",
  "user-context": "static-1.5538",
  "react-flip-move": "static-1.83",
  "framework-data-schema-quick-fetch": "static-1.7282",
  "onboarding-data-sync-lib": "static-1.2854",
  "growth-onboarding-next-action-components": "static-1.3031",
  "user-context-client": "static-1.4994",
  "getting-started-shared-tasks-store": "static-1.18701",
  "InboxConnectUtils": "static-4.15861",
  "meetings-connect-utils-lib": "static-1.8104",
  "onboarding-scopes": "static-1.6938"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31034",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55621",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8523",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11971",
  "I18n": "/I18n/static-7.1709",
  "quartz": "/quartz/static-1.7677",
  "quartz-config": "/quartz-config/static-1.1455",
  "quartz-core": "/quartz-core/static-1.6896",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1107",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55608",
  "feedback-utils": "/feedback-utils/static-1.55612",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4945",
  "forms-utils-lib": "/forms-utils-lib/static-1.13351",
  "foundations-assets": "/foundations-assets/static-1.5373",
  "foundations-components": "/foundations-components/static-1.8763",
  "foundations-theming": "/foundations-theming/static-1.4974",
  "hub-http": "/hub-http/static-1.6690",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12278",
  "icons": "/icons/static-2.704",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4236",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17222",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5663",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tinymce-plugins": "/tinymce-plugins/static-1.58526",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1278",
  "UIComponents": "/UIComponents/static-3.8917",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3954",
  "quartz-webpack": "/quartz-webpack/static-1.3901",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2690",
  "property-description-translator": "/property-description-translator/static-1.4304",
  "HeadJS": "/HeadJS/static-2.824",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3634",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4791",
  "jasmine-runner": "/jasmine-runner/static-1.6937",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.275",
  "dispatcher": "/dispatcher/static-1.148",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4980",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.650",
  "quartz-auth": "/quartz-auth/static-1.1352",
  "quartz-head": "/quartz-head/static-1.1342",
  "quartz-i18n": "/quartz-i18n/static-1.1352",
  "quartz-routing": "/quartz-routing/static-1.1107",
  "quartz-test": "/quartz-test/static-1.1352",
  "quartz-tracking": "/quartz-tracking/static-1.1056",
  "trellis-components": "/trellis-components/static-1.3132",
  "ui-fonts": "/ui-fonts/static-1.1233",
  "usage-tracker-container": "/usage-tracker-container/static-1.7798",
  "usage-tracker-core": "/usage-tracker-core/static-1.7658",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.373",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "reference-resolvers": "/reference-resolvers/static-1.8668",
  "sanitize-text": "/sanitize-text/static-1.8643",
  "PatternValidationJS": "/PatternValidationJS/static-1.3368",
  "ReduxMessenger": "/ReduxMessenger/static-2.10854",
  "outpost": "/outpost/static-1.4613",
  "rpc-client-utils": "/rpc-client-utils/static-1.5154",
  "sanitize": "/sanitize/static-1.4959",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5032",
  "floating-ui": "/floating-ui/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9914",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3113",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3457",
  "foundations-theming-base": "/foundations-theming-base/static-1.3959",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.407",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.184",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10041",
  "atom": "/atom/static-1.5556",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8437",
  "ContentUtils": "/ContentUtils/static-1.69499",
  "data-token-picker": "/data-token-picker/static-1.17150",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8405",
  "hub-http-contrib": "/hub-http-contrib/static-1.3517",
  "interframe": "/interframe/static-3.5226",
  "layout-dnd-components": "/layout-dnd-components/static-1.13242",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12217",
  "property-translator": "/property-translator/static-1.5864",
  "react-codemirror": "/react-codemirror/static-1.11126",
  "react-colorpicker": "/react-colorpicker/static-2.10694",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8597",
  "rich-text-lib": "/rich-text-lib/static-1.20570",
  "tinymce-data": "/tinymce-data/static-1.41497",
  "tinymce-themes": "/tinymce-themes/static-1.57382",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10347",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5686",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16976",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10921",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10919",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5494",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1496",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.564",
  "chirp-fetch": "/chirp-fetch/static-1.2389",
  "stylex-utils": "/stylex-utils/static-1.176",
  "chatspot-core": "/chatspot-core/static-1.23941",
  "copilot-toolkit": "/copilot-toolkit/static-1.12171",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13520",
  "data-fetching-client": "/data-fetching-client/static-1.10124",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5243",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9107",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29593",
  "usage-tracker": "/usage-tracker/static-1.7808",
  "cms-field-types": "/cms-field-types/static-1.5294",
  "content-icons-ui": "/content-icons-ui/static-1.2466",
  "integrations-lib": "/integrations-lib/static-1.17451",
  "customer-data-objects": "/customer-data-objects/static-1.8191",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2223",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5073",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4626",
  "poll-commands": "/poll-commands/static-1.3962",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9561",
  "video-components-external": "/video-components-external/static-1.12459",
  "video-data-lib": "/video-data-lib/static-1.36117",
  "audio-components": "/audio-components/static-1.6587",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1010",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30075",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1788",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.742",
  "ui-universal-auth": "/ui-universal-auth/static-1.9763",
  "urlinator": "/urlinator/static-1.4998",
  "video-components": "/video-components/static-1.14461",
  "video-embed": "/video-embed/static-1.36951",
  "ts-schema": "/ts-schema/static-1.4400",
  "ContentData": "/ContentData/static-1.69574",
  "layout-data-lib": "/layout-data-lib/static-1.10542",
  "react-dnd-compat": "/react-dnd-compat/static-1.5094",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2033",
  "external-options-client-types": "/external-options-client-types/static-1.4444",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6076",
  "hs-resources": "/hs-resources/static-1.671",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4156",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9373",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3543",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11629",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5915",
  "magpie-types": "/magpie-types/static-1.5375",
  "simple-logging-lib": "/simple-logging-lib/static-1.3535",
  "avatar-components": "/avatar-components/static-1.2971",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10316",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7065",
  "flux-actions": "/flux-actions/static-1.381",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5367",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14866",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6107",
  "laboratory-lib": "/laboratory-lib/static-3.7632",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8247",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10765",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1201",
  "breeze-engine-core": "/breeze-engine-core/static-1.1501",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1132",
  "navigation-messaging": "/navigation-messaging/static-1.8517",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19656",
  "nudge-client-utils": "/nudge-client-utils/static-1.3439",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.327",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1559",
  "social-insights-client-types": "/social-insights-client-types/static-1.22948",
  "advanced-menus-core": "/advanced-menus-core/static-1.15831",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12580",
  "ExportDialog": "/ExportDialog/static-6.10858",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35221",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4118",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4449",
  "event-emitter": "/event-emitter/static-1.1446",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.496",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4340",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3780",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4013",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6246",
  "reactive-lib": "/reactive-lib/static-1.1205",
  "trellis-migration-context": "/trellis-migration-context/static-1.65",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.826",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3497",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.635",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30827",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3196",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3515",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "whisper-core-api": "/whisper-core-api/static-1.7656",
  "fsm": "/fsm/static-1.4242",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15830",
  "simple-menus-lib": "/simple-menus-lib/static-1.17347",
  "settings-ui-lib": "/settings-ui-lib/static-1.13012",
  "persist-promise": "/persist-promise/static-1.4190",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.80",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7377",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10441",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19583",
  "growth-data-modal": "/growth-data-modal/static-1.6149",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3003",
  "navigation-components": "/navigation-components/static-1.19190",
  "nest": "/nest/static-1.719",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8146",
  "user-context": "/user-context/static-1.5538",
  "react-flip-move": "/react-flip-move/static-1.83",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7282",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2854",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3031",
  "user-context-client": "/user-context-client/static-1.4994",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18701",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15861",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8104",
  "onboarding-scopes": "/onboarding-scopes/static-1.6938"
}
};
